import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, useEffect } from "react";
import { DataTable, CampusSingleDrawerUser, ToolbarSelect } from "../../../../";
import { Grid } from "@material-ui/core";
import VisibilityIcon from "@material-ui/icons/Visibility";

var CampusSingleTabUsers = function CampusSingleTabUsers(props) {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      openDrawer = _useState2[0],
      setOpenDrawer = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      userSelected = _useState4[0],
      setUserSelected = _useState4[1];

  var toggleDrawer = function toggleDrawer() {
    setOpenDrawer(!openDrawer);
  };

  var handleSelectUser = function handleSelectUser(key) {
    // let auxUsers = [...props.users];
    // console.log("it works?", auxUsers);
    if (key) {
      var user = props.users.find(function (user) {
        return user.key === key;
      });
      setUserSelected(user);
      toggleDrawer();
    } else {
      setUserSelected(null);
      toggleDrawer();
    }
  };

  var handleSelectUsers = function handleSelectUsers(type, data) {
    switch (type) {
      case "assign_users_to_group":
        props.handleAssignUsersToGroup(data.map(function (index) {
          return props.users[index.dataIndex].key;
        }));
        break;

      default:
        break;
    }
  };

  var options = {
    filter: true,
    selectableRows: "multiple",
    filterType: "dropdown",
    responsive: "stacked",
    rowsPerPage: 100,
    customToolbarSelect: function customToolbarSelect(selectedRows) {
      return /*#__PURE__*/React.createElement(ToolbarSelect, {
        selectedRows: selectedRows,
        handleClick: function handleClick(type, rows) {
          rows && rows.data ? handleSelectUsers(type, rows.data) : console.log("error data rows");
        },
        items: props.translation ? props.translation.datatables ? props.translation.datatables.users ? props.translation.datatables.users.toolbar ? props.translation.datatables.users.toolbar.assign_users_group || [] : [] : [] : [] : []
      });
    }
  };
  var auxTranslation = props.translation;

  if (auxTranslation && auxTranslation.datatables && auxTranslation.datatables.users) {
    !auxTranslation.datatables.users.columns.find(function (column) {
      return column.name === "options";
    }) ? auxTranslation.datatables.users.columns.push({
      label: "",
      name: "options",
      options: {
        filter: false,
        sort: false,
        viewColumns: false,
        empty: true,
        label: false,
        customBodyRender: function customBodyRender(value, tableMeta, updateValue) {
          return /*#__PURE__*/React.createElement(VisibilityIcon, {
            onClick: function onClick() {
              return handleSelectUser(tableMeta.rowData[0]);
            }
          });
        }
      }
    }) : auxTranslation.datatables.users.columns[auxTranslation.datatables.users.columns.length - 1] = {
      label: "",
      name: "options",
      options: {
        filter: false,
        sort: false,
        viewColumns: false,
        empty: true,
        label: false,
        customBodyRender: function customBodyRender(value, tableMeta, updateValue) {
          return /*#__PURE__*/React.createElement(VisibilityIcon, {
            onClick: function onClick() {
              return handleSelectUser(tableMeta.rowData[0]);
            }
          });
        }
      }
    };
  }

  return /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(CampusSingleDrawerUser, {
    user: userSelected,
    open: openDrawer,
    toggleDrawer: toggleDrawer,
    groups: props.groups,
    isGroupsEditable: true,
    handleEditUser: props.handleEditUser,
    handleDeleteUser: props.handleDeleteUser,
    translation: props.translation ? props.translation.drawers ? props.translation.drawers.user : null : null
  }), /*#__PURE__*/React.createElement(DataTable, {
    data: props.users,
    translation: auxTranslation ? auxTranslation.datatables ? auxTranslation.datatables.users || null : null : null,
    options: options
  }));
};

export { CampusSingleTabUsers };